<div *ngIf="open" class="modal-back" (click)="cancel()">
  <section
    class="modal card confirm-dialog"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="confirm-dialog-title"
    aria-describedby="confirm-dialog-message"
    (click)="$event.stopPropagation()"
  >
    <div class="confirm-icon" [class.confirm-icon-danger]="tone === 'danger'" aria-hidden="true">
      <svg viewBox="0 0 24 24">
        <path d="M12 8v5M12 17h.01" />
        <path d="M10.3 3.9 2.6 17.2A2 2 0 0 0 4.3 20h15.4a2 2 0 0 0 1.7-2.8L13.7 3.9a2 2 0 0 0-3.4 0Z" />
      </svg>
    </div>

    <span class="eyebrow">{{ eyebrow }}</span>
    <h2 id="confirm-dialog-title">{{ title }}</h2>
    <p id="confirm-dialog-message">{{ message }}</p>

    <div class="confirm-actions">
      <button class="btn btn-ghost" type="button" [disabled]="busy" (click)="cancel()">
        {{ cancelLabel }}
      </button>
      <button
        class="btn"
        [class.btn-primary]="tone === 'primary'"
        [class.btn-danger]="tone === 'danger'"
        type="button"
        [disabled]="busy"
        (click)="confirmed.emit()"
      >
        {{ busy ? busyLabel : confirmLabel }}
      </button>
    </div>
  </section>
</div>
